<template>
    <div
        class="align-center row"
        style="
            width: 100%;
            background: #01a7e71f;
            border-radius: 16px;
            height: 160px;
        "
    >
        <img
            :src="imageSrc"
            :alt="imageAlt"
            :style="{
                width: imageSize + 'px',
                height: imageSize + 'px',
            }"
        />
        <div class="column">
            <p style="font-size: 24px; font-weight: bold">{{ title }}</p>
            <p style="font-size: 20px">{{ content }}</p>
        </div>
    </div>
</template>

<script>
import { defineComponent, onMounted } from "vue";
import TrayArrowDown from "vue-material-design-icons/TrayArrowDown.vue";

export default defineComponent({
    props: {
        imageSrc: String,
        imageAlt: {
            type: String,
            default: "Image",
        },
        imageSize: {
            type: Number,
            default: 64,
        },
        title: String,
        content: String,
    },
    components: {
        TrayArrowDown,
    },
    setup() {
        onMounted(() => {});
        return {};
    },
});
</script>

<style scoped>
button {
    padding: 8px;
    border: 0.5px solid #b0b0b0;
}

.video {
    width: 100%;
    padding: 24px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.v-img__img--contain {
    object-fit: fill !important;
}
</style>
